import type { ReactNode } from "react";
import { IconChevronRight } from "@tabler/icons-react";
import { cn } from "../../lib/utils";

type PromoCardProps = {
  leading: ReactNode;
  title: string;
  description: string;
  onClick: () => void;
  className?: string;
};

function PromoCard({
  leading,
  title,
  description,
  onClick,
  className,
}: PromoCardProps): React.JSX.Element {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex w-full items-center gap-4 rounded-2xl bg-ds-slate-50 p-4 text-left font-dm-sans cursor-pointer",
        className
      )}
    >
      <div className="shrink-0">{leading}</div>
      <div className="flex flex-1 flex-col gap-1 min-w-0">
        <p className="m-0 font-semibold text-base/5 text-ds-black">{title}</p>
        {description !== "" && (
          <p className="m-0 text-xs/4 text-ds-slate-600 line-clamp-3">
            {description}
          </p>
        )}
      </div>
      <IconChevronRight
        size={24}
        stroke={1.5}
        className="shrink-0 text-ds-slate-800"
      />
    </button>
  );
}

export { PromoCard, type PromoCardProps };
